export const Selectors = {
    trialTrainingForm: '.employee-form form',
    trialTrainingFormContent: '.employee-form-content'
};

export const PluginNames = {
    3600: 'tx_igteam_team'
};